<!-- START HEADER-->
<header class="header" app-header></header>
<!-- END HEADER-->

<!-- START SIDEBAR-->
<nav class="page-sidebar" id="sidebar" app-sidebar (messageEvent)="receiveMessage($event)"></nav>
<!-- END SIDEBAR-->

<!-- START PAGE CONTENT-->
<div class="content-wrapper">
  <div class="content-section">
    <router-outlet></router-outlet>
  </div>
  <footer class="page-footer" app-footer></footer>
</div>
<!-- END PAGE CONTENT-->

<!-- START BACKGROUND OVERLAY -->
<!--span app-sidebar (messageEvent)="receiveMessage($event)"></span-->
<div class="pop-up-bg">
  <div class="side-popup" id="side-popup">
    <ul class="comp-list">
      <li class="head"><i>Select Company: </i></li>
      <li *ngFor="let x of complist" class="comp-liststyle" (click)="goComp(x.id)">
        <ngx-avatar name="{{x.name}}" size="32" textSizeRatio="2.5" initialsSize="3"></ngx-avatar>
        <h6 class="ml-2 mb-1">{{x.name}}</h6>
      </li>
      <li class="foot text-center" routerLink="/company/create">
        <span><i class="ti-plus"></i> Register Company</span>
      </li>
    </ul>
  </div>
</div>

<div class="account-bg"></div>


<!-- END BACKGROUND OVERLAY -->

<!--div class="sidenav-backdrop backdrop"></div>
<div class="preloader-backdrop">
  <div class="page-preloader">Loading</div>
</div-->
